module.exports = __webpack_public_path__ + "img/airesearch_logo.048b2550.webp";